import React, { useCallback, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
import style from './style.module.css';
import { emptyArray } from 'ui-components/default-props/empty';
import { sortPremiumFeatures } from '../../../../../hooks/use-seller-feature';

const DEFAULT_NUMBER_OF_FEATURES_TO_DISPLAY = 3;

/**
 * @param {object} props
 * @param {string[]} [props.includedFeatureIds] - Array of feature IDs to display
 * @returns {JSX.Element}
 */
export const PremiumFeatures = ({ includedFeatureIds = emptyArray }) => {
  const [showAllFeatures, setShowAllFeatures] = useState(false);

  const onExpanderButtonClick = useCallback(() => setShowAllFeatures((prev) => !prev), [setShowAllFeatures]);

  const orderedFeatureIds = useMemo(() => sortPremiumFeatures(includedFeatureIds), [includedFeatureIds]);
  const featureItems = useMemo(
    () =>
      orderedFeatureIds.map((featureId) => {
        const messageDescriptor = messages[featureId] ?? featureId;
        return <Text key={featureId} className={style['feature-line-item']} textType={TextType.Caption} value={messageDescriptor} />;
      }),
    [orderedFeatureIds],
  );

  if (orderedFeatureIds.length > DEFAULT_NUMBER_OF_FEATURES_TO_DISPLAY) {
    const icon = showAllFeatures ? faChevronUp : faChevronDown;
    return (
      <>
        <Button className={style['feature-expander-button']} onClick={onExpanderButtonClick} theme='link'>
          <Text formattedMessageValues={{ count: featureItems.length }} textType={TextType.Caption} value={messages.moreIncluded} />
          <FontAwesomeIcon className={style['feature-expander-icon']} icon={icon} />
        </Button>
        {showAllFeatures ? featureItems : null}
      </>
    );
  }
  return featureItems;
};
